import { render, staticRenderFns } from "./mainland-freight.vue?vue&type=template&id=aaa41ede&"
import script from "./mainland-freight.vue?vue&type=script&lang=ts&"
export * from "./mainland-freight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports